import { render, staticRenderFns } from "./create-offer.vue?vue&type=template&id=01162c7d&"
import script from "./create-offer.vue?vue&type=script&lang=ts&"
export * from "./create-offer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-offer.vue"
export default component.exports